
export default {
  state: {
    //左侧功能栏状态
    isCollapse: true,
    //面包屑选项卡
    tabsList: [
      {
        path: '/',
        name: 'dashboard',
        label: '首页',
        icon: 'dashboard'
      }
    ],
    currentMenu: null,
    //用户权限路由菜单
    menu: []

  },
  mutations: {
    //控制左侧菜单栏的显示隐藏，同时左侧logo也根据状态变化
    collapseMenu(state) {
      state.isCollapse = !state.isCollapse
    },
    //登录后获取到菜单展示状态
    getMenuzt(state,ztval=true) {
      state.isCollapse =ztval
    },

    //点击菜单跳转路由，将路由插入到面包屑
    selectMenu(state, val) {
      if (val.name != 'dashboard') {
        state.currentMenu = val
        const result = state.tabsList.findIndex(item => item.name === val.name)
        if (result === -1) {
          state.tabsList.push(val)
        }
      } else {
        state.currentMenu = null
      }

    },

    //关闭面包屑选项卡
    closeTag(state, val) {
      const result = state.tabsList.findIndex(item => item.name === val.name)
      state.tabsList.splice(result, 1)
    },
    //关闭全部标签（保留首页）
    closeAllTags(state) {
      // 保留首页标签（name为'dashboard'）
      state.tabsList = state.tabsList.filter(item => 
        item.name === 'dashboard'
      )
    },
    //关闭其他标签（保留指定的标签和首页）
    closeOtherTags(state, payload) {
      const keepTags = payload.keepTags || []
      // 保留指定的标签和首页标签
      state.tabsList = state.tabsList.filter(item => {
        // 保留首页标签
        if (item.name === 'dashboard') {
          return true
        }
        // 保留指定的标签
        return keepTags.some(keepTag => keepTag.name === item.name)
      })
    },
    //关闭多个标签
    closeMultipleTags(state, payload) {
      const tagsToClose = payload.tags || []
      const namesToClose = tagsToClose.map(tag => tag.name)
      // 过滤掉需要关闭的标签，但保留首页标签
      state.tabsList = state.tabsList.filter(item => {
        // 始终保留首页标签
        if (item.name === 'dashboard') {
          return true
        }
        // 如果不在关闭列表中，则保留
        return !namesToClose.includes(item.name)
      })
    },
    //根据返回数据，写入功能菜单列表
    setMenu(state, val) {
      state.menu = val
    },
    //清空功能菜单项目列表
    clearMenu(state) {
      state.menu = []
    },
    //动态添加路由，将获取到的功能菜单依次加入到主框架页面中
    addMenu(state, router) {
      if (!state.menu) {
        return
      }
      const menu = JSON.parse(JSON.stringify(state.menu))
      const menuArray = []
      menu.forEach(item=>{
        //1.二级子菜单路由的判断添加
        if(item.children){//判断存在二级菜单，就为其添加路由
          item.children=item.children.map(item=>{
            item.component=()=>import(`../views/${item.url}`)
            return item
          })
          menuArray.push(...item.children)//将子菜单解构进路由数组
        }

        //2.一级菜单路由的判断添加
        item.component=()=>import(`../views/${item.url}`)
        item.children=[]//将一级菜单的子菜单去掉，避免重复路由报错
        menuArray.push(item)
      });
      //路由的动态添加
      menuArray.forEach(item => {
        router.addRoute('Main', item)
      })
    },
    /** 小程序 H5：动态菜单路由挂到 Hcore 下（与 addMenu / Main 对称） */
    addH5Menu(state, router) {
      if (!state.menu || !router) return
      const menu = JSON.parse(JSON.stringify(state.menu))
      const menuArray = []
      menu.forEach((item) => {
        if (item.children) {
          item.children = item.children.map((child) => {
            child.component = () => import(`../views/${child.url}`)
            return child
          })
          menuArray.push(...item.children)
        }
        item.component = () => import(`../views/${item.url}`)
        item.children = []
        menuArray.push(item)
      })
      menuArray.forEach((item) => {
        router.addRoute('Hcore', item)
      })
    }
  }
}
